import React from "react";

import SecondaryButton from "../../../widgets/Buttons/SecondaryButton";
import ErrorSnackbar from "../../../widgets/Snackbar/ErrorSnackbar";
import styles from "../../../components/StudentDetails/StudentDetails.module.scss";

const StudentNotFoundState = ({
  errorMessage,
  onBack,
  message = "No student data found.",
}) => (
  <div className={styles.wrapper}>
    <div className={styles.headerBox}>
      <SecondaryButton
        onClick={onBack}
        className={styles.headerButton}
      >
        Go Back
      </SecondaryButton>
    </div>
    <p className={styles.noData}>{message}</p>
    <ErrorSnackbar
      open={!!errorMessage}
      message={errorMessage}
      onClose={() => {}}
    />
  </div>
);

export default StudentNotFoundState;
